<ng-container *ngIf="!assignmentSchedules.length">
    <div class="alert alert-secondary">
        {{'assignmentSchedules.emptyList' | transloco}}
    </div>
</ng-container>

<ng-container *ngIf="assignmentSchedules.length">
    <div class="d-flex flex-column gap-2 text-center">
        <div role="button" *ngFor="let assignmentSchedule of assignmentSchedules"
            (click)="routeToAssignment(assignmentSchedule.id)">
            <div class="text-decoration-none text-dark w-100 shadow-sm p-3 bg-white d-block rounded">
                <div class="d-flex align-items-center gap-3 w-100">
                    <div class="flex-grow-1 overflow-hidden text-start">
                        <div class="d-flex align-items-center">
                            <i class="fa-regular fa-calendar-days me-1"></i>
                            <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
                                {{ assignmentSchedule.from | date: "EE dd.MM.yy" }}
                            </span>
                            <span class="fs-4 px-1">-</span>
                            <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
                                {{ assignmentSchedule.to | date: "EE dd.MM.yy" }}
                            </span>
                        </div>
                        <div class="fs-4 mb-0 fw-bold text-truncate">
                            <span class="h8">{{assignmentSchedule.sportName}} | {{assignmentSchedule.name}}</span>
                        </div>
                    </div>
                    <div>
                        <i class="fa fa-chevron-right text-primary"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>